import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { MaterialStackModule } from '@zerops/zerops/core/material-stack';
import { AutomaticTopUpConfigDialogFeature } from './automatic-top-up-config-dialog.feature';
import { AutomaticPaymentConfigDialogEffect } from './automatic-top-up-config-dialog.effect';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { AutomaticTopUpConfigFormComponent } from './components/automatic-top-up-config-form.component';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { TranslocoModule } from '@ngneat/transloco';
import { FormSectionModule } from '@zerops/zui/form-section';

@NgModule({
  declarations: [ AutomaticTopUpConfigDialogFeature ],
  imports: [
    CommonModule,
    MaterialStackModule,
    EffectsModule.forFeature([ AutomaticPaymentConfigDialogEffect ]),
    ZefDialogModule,
    ZuiSeparatorComponent,
    ZefScrollbarComponent,
    AutomaticTopUpConfigFormComponent,
    ZefProgressErrorModule,
    TranslocoModule,
    FormSectionModule
  ],
  exports: [ AutomaticTopUpConfigDialogFeature ]
})
export class AutomaticTopUpConfigDialogModule {

}
